import { render, staticRenderFns } from "./DetailHeaderBar.vue?vue&type=template&id=963ba8b6&scoped=true"
import script from "./DetailHeaderBar.vue?vue&type=script&lang=js"
export * from "./DetailHeaderBar.vue?vue&type=script&lang=js"
import style0 from "./DetailHeaderBar.vue?vue&type=style&index=0&id=963ba8b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "963ba8b6",
  null
  
)

export default component.exports